import { css } from '@emotion/react';
import { helperDesktopCustomScroll } from '../../helpers';

export const stylesDesktop = css`
  * {
    ${helperDesktopCustomScroll};

    box-sizing: inherit;

    &:before,
    &:after {
      box-sizing: inherit;
    }
  }

  html {
    box-sizing: border-box;

    /* 6px @ 699px increasing to 10px @ 999px */
    @media (min-width: 699px) and (max-width: 999px) {
      font-size: calc(0.375rem + ((1vw - 6.99px) * 1.3333));
    }

    @media (max-width: 698px) {
      font-size: 6px;
    }
  }

  #app {
    display: flex;
    flex-direction: column;
    min-width: 100rem;
    min-height: 100%;
  }

  input[type='number'] {
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      margin: 0;
      -webkit-appearance: none;
    }
  }

  input[type='search'] {
    &::-webkit-search-cancel-button {
      display: none;
    }
  }

  button {
    outline: none;
    cursor: pointer;
    font-feature-settings: inherit;
    background-color: transparent;
  }
`;
